import { doc, getDoc, getFirestore, runTransaction, serverTimestamp } from 'firebase/firestore';

import { remoteConfigApp } from 'src/api/remoteConfig';

const db = getFirestore(remoteConfigApp, 'goodlook');
const QUIZZ_COLLECTION = 'quizz_gl';

export const normalizeQuizzEmail = (email: string) => email.trim().toLowerCase();

export const hasAnsweredQuizz = async (email: string) => {
   try {
      const docSnap = await getDoc(doc(db, QUIZZ_COLLECTION, normalizeQuizzEmail(email)));
      return { answered: docSnap.exists(), success: 'true' };
   } catch (error: any) {
      console.error('Error checking quizz in Firestore:', error);
      return { answered: false, errors: error.message, success: 'false' };
   }
};

export const saveQuizzAnswers = async (data: { name: string; email: string; [key: string]: any }) => {
   const email = normalizeQuizzEmail(data.email);
   const docRef = doc(db, QUIZZ_COLLECTION, email);
   try {
      // Transaction avoids overwriting an existing submission for the same email
      const created = await runTransaction(db, async (transaction) => {
         const docSnap = await transaction.get(docRef);
         if (docSnap.exists()) return false;
         transaction.set(docRef, { ...data, email, createdAt: serverTimestamp() });
         return true;
      });

      if (!created) return { errors: 'Este correo ya respondió el quiz', alreadyAnswered: true, success: 'false' };
      return { success: 'true' };
   } catch (error: any) {
      console.error('Error saving quizz in Firestore:', error);
      return { errors: error.message, success: 'false' };
   }
};
